export default __webpack_public_path__ + "static/media/17.cdaab700.png";